// -*- coding: utf-8 -*-
// Generated by scripts/generate_from_specs.py
// Subjects

export default {
    ALGEBRA: "d&WXdXWF.qs0Xlaxq.0t5msbL5",
    ANTHROPOLOGY: "d&WXdXWF.K80UMYnW.ViBlbQR&",
    ARITHMETIC: "d&WXdXWF.qs0Xlaxq.nG96nHDc",
    ARTS: "d&WXdXWF.5QAjgfv7",
    ASTRONOMY: "d&WXdXWF.i1IdaNwr.mjSF4QlF",
    BIOLOGY: "d&WXdXWF.i1IdaNwr.uErN4PdS",
    CALCULUS: "d&WXdXWF.qs0Xlaxq.8rJ57ht6",
    CHEMISTRY: "d&WXdXWF.i1IdaNwr.#r5ocgid",
    CIVIC_EDUCATION: "d&WXdXWF.K80UMYnW.F863vKiF",
    COMPUTER_SCIENCE: "d&WXdXWF.e#RTW9E#",
    CURRENT_EVENTS: "PbGoe2MV.J7CU1IxN",
    DAILY_LIFE: "PbGoe2MV",
    DANCE: "d&WXdXWF.5QAjgfv7.BUMJJBnS",
    DIGITAL_LITERACY: "BCG3&slG.wZ3EAedB",
    DIVERSITY: "PbGoe2MV.EHcbjuKq",
    DRAMA: "d&WXdXWF.5QAjgfv7.XsWznP4o",
    EARTH_SCIENCE: "d&WXdXWF.i1IdaNwr.zbDzxDE7",
    ENTREPRENEURSHIP: "PbGoe2MV.kyxTNsRS",
    ENVIRONMENT: "PbGoe2MV.tS7WKnZ7",
    FINANCIAL_LITERACY: "PbGoe2MV.HGIc9sZq",
    FOR_TEACHERS: "ziJ6PCuU",
    FOUNDATIONS: "BCG3&slG",
    FOUNDATIONS_LOGIC_AND_CRITICAL_THINKING: "BCG3&slG.0&d0qTqS",
    GEOMETRY: "d&WXdXWF.qs0Xlaxq.lb7ELcK5",
    GUIDES: "ziJ6PCuU.RLfhp37t",
    HISTORY: "d&WXdXWF.zWtcJ&F2",
    INDUSTRY_AND_SECTOR_SPECIFIC: "l7DsPDlm.ISEXeZt&.pRvOzJTE",
    LANGUAGE_LEARNING: "d&WXdXWF.JDUfJNXc",
    LEARNING_SKILLS: "BCG3&slG.fP2j70bj",
    LESSON_PLANS: "ziJ6PCuU.lOBPr5ix",
    LITERACY: "BCG3&slG.HLo9TbNq",
    LITERATURE: "d&WXdXWF.kHKJ&PbV.DJLBbaEk",
    LOGIC_AND_CRITICAL_THINKING: "d&WXdXWF.kHKJ&PbV.YMBXStib",
    MATHEMATICS: "d&WXdXWF.qs0Xlaxq",
    MECHANICAL_ENGINEERING: "d&WXdXWF.e#RTW9E#.8ZoaPsVW",
    MEDIA_LITERACY: "PbGoe2MV.UOTL#KIV",
    MENTAL_HEALTH: "PbGoe2MV.d8&gCo2N",
    MUSIC: "d&WXdXWF.5QAjgfv7.u0aKjT4i",
    NUMERACY: "BCG3&slG.Tsyej9ta",
    PHYSICS: "d&WXdXWF.i1IdaNwr.r#wbt#jF",
    POLITICAL_SCIENCE: "d&WXdXWF.K80UMYnW.K72&pITr",
    PROFESSIONAL_SKILLS: "l7DsPDlm.#N2VymZo",
    PROGRAMMING: "d&WXdXWF.e#RTW9E#.CfnlTDZ#",
    PUBLIC_HEALTH: "PbGoe2MV.kivAZaeX",
    READING_AND_WRITING: "d&WXdXWF.kHKJ&PbV",
    READING_COMPREHENSION: "d&WXdXWF.kHKJ&PbV.r7RxB#9t",
    SCHOOL: "d&WXdXWF",
    SCIENCES: "d&WXdXWF.i1IdaNwr",
    SKILLS_TRAINING: "l7DsPDlm.ISEXeZt&.&1WpYE&n",
    SOCIAL_SCIENCES: "d&WXdXWF.K80UMYnW",
    SOCIOLOGY: "d&WXdXWF.K80UMYnW.75WBu1ZS",
    STATISTICS: "d&WXdXWF.qs0Xlaxq.jNm15RLB",
    TECHNICAL_AND_VOCATIONAL_TRAINING: "l7DsPDlm.ISEXeZt&",
    TOOLS_AND_SOFTWARE_TRAINING: "l7DsPDlm.ISEXeZt&.1JfIbP&N",
    VISUAL_ART: "d&WXdXWF.5QAjgfv7.4LskOFXj",
    WEB_DESIGN: "d&WXdXWF.e#RTW9E#.P7s8FxQ8",
    WORK: "l7DsPDlm",
    WRITING: "d&WXdXWF.kHKJ&PbV.KFJOCr&6",
};
